import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';


function DefaultSuccessMessage() {
  return (
    <div
      className={classNames(
        'newsletter-signup__submitted-message',
        'mt1 df justify-center',
      )}
    >
      <p className="publico-hed f6 mb7">
        {i18next.t('You have been successfully added to our newsletter')}
      </p>
    </div>
  );
}

export default DefaultSuccessMessage;
